import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailContentUtils" */ './lazyIndex'),
    { name: 'MailContentUtils' }
);

export const lazyCreateMailResponseBodyContent: LazyImport<
    typeof lazyIndex.createMailResponseBodyContent,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.createMailResponseBodyContent);

export const lazyCreateQuotedBodyForPstOperation: LazyImport<
    typeof lazyIndex.createQuotedBodyForPstOperation,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.createQuotedBodyForPstOperation);
